export default "__VITE_ASSET__3pFAuR9B__"